module.exports = __webpack_public_path__ + "img/icon-media-locked.b7251027.svg";